import React from "react";
import { Helmet } from "react-helmet";
import Splash from "../components/splash/splash";
import Bio from "../components/bio/bio";
import Banner from "../components/banner/banner";
import Discography from "../components/discography/discography";
import UpcomingShows from "../components/upcoming-shows/upcoming-shows";
import PastShows from "../components/past-shows/past-shows";
import Gallery from "../components/gallery/gallery";
import Contact from "../components/contact/contact";
import Resources from "../components/resources/resources";
import Header from "../components/header/header";
import Copyright from "../components/copyright/copyright";

const IndexPage = () => {
  return (
    <main>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Milky Haze Musik</title>
        <link rel="canonical" href="http://milkyhazemusik.com" />
      </Helmet>
      <Header />
      <Splash />
      <Bio />
      <Discography />
      <UpcomingShows />
      <PastShows />
      <Gallery />
      <Contact />
      <Resources />
      <Banner />
      <Copyright />
    </main>
  );
};

export default IndexPage;
